import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { fetchIncidentStatus } from 'actions/profileActions';
import { fetchTeamTemplates } from 'actions/teamsActions';
import TemplateWizard from './TemplateWizard';
import { useFetchIncidentWorkspaceTeamStatus } from 'hooks/useFetchIncidentWorkspaceTeamStatus';

const IncidentTeamsFeatures = () => {
  const [showSelectTeamsTemplateDialog, setShowSelectTeamsTemplateDialog] =
    useState(false);

  const currentIncident = useSelector((state: any) => {
    return state.app.currentIncident;
  });
  const teamsTemplates = useSelector((state: any) => {
    return state.app.teamsTemplates;
  });
  const tenantId = useSelector((state: any) => {
    return state.app.tenantId;
  });

  const { data: teamsStatus, refetch: refetchTeamsStatus } = useFetchIncidentWorkspaceTeamStatus();

  useEffect(() => {
    if (teamsStatus === 'inprogress') {
      const intervalId = setInterval(() => {
        refetchTeamsStatus();
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [teamsStatus, refetchTeamsStatus]);

  const dispatch = useDispatch();

  const onClickGenerateTeamsSite = async (incidentId: any) => {
    await dispatch(fetchIncidentStatus(incidentId));

    if (currentIncident?.teams_status === 'unstarted') {
      setShowSelectTeamsTemplateDialog(true);
      if (teamsTemplates.length == 0) {
        dispatch(fetchTeamTemplates(tenantId));
      }
    }
  };

  return (
    <>
      {!!tenantId && (
        <>
          {(!!currentIncident &&
            !currentIncident?.teams_id &&
            !currentIncident?.channel_id &&
            !currentIncident?.sharepoint_location &&
            teamsStatus === 'unstarted' && (
              <>
                <StylishNewButton
                  className="button--secondary w-100 w-md-auto ms-0 ms-md-3 mt-2 mt-md-0"
                  onClick={() => onClickGenerateTeamsSite(currentIncident?.id)}
                >
                  Generate Teams Site
                </StylishNewButton>
                {showSelectTeamsTemplateDialog && (
                  <TemplateWizard
                    tenantId={tenantId}
                    workspaceType="incident"
                    workspaceId={currentIncident.id}
                    setShowSelectTeamsTemplateDialog={
                      setShowSelectTeamsTemplateDialog
                    }
                  />
                )}
              </>
            )) ||
            (teamsStatus === 'inprogress' && (
              <div style={{ marginLeft: '16px' }}>
                Creating Teams Workspace...
              </div>
            )) ||
            (teamsStatus === 'done' && (
              <div style={{ marginLeft: '16px' }}>Teams Workspace Created!</div>
            ))}
        </>
      )}
    </>
  );
};
export default IncidentTeamsFeatures;
